import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import "./OrderConfirm.css";

const OrderConfirm = ({ order }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!order) {
      navigate("/products");
    }
  }, [order, navigate]);

  if (!order) return null;

  return (
    <div className="order-confirm-page">
      <div className="confirm-container">
        <div className="success-header">
          <span className="success-icon">✓</span>
          <h1>Ordine Confermato!</h1>
          <p>Grazie per il vostro acquisto</p>
        </div>

        <div className="order-details-card">
          <div className="order-number">
            <h2>Numero Ordine</h2>
            <p className="order-id">{order.orderId}</p>
            <p className="order-date">Data: {order.date}</p>
          </div>

          <div className="order-info-grid">
            <div className="info-section">
              <h3>👤 Cliente</h3>
              <p>{order.user.name}</p>
              <p>{order.user.email}</p>
            </div>

            <div className="info-section">
              <h3>📍 Indirizzo di Spedizione</h3>
              <p>
                {order.shipping.firstName} {order.shipping.lastName}
              </p>
              <p>{order.shipping.address}</p>
              <p>
                {order.shipping.postalCode} {order.shipping.city}
              </p>
              <p>{order.shipping.country}</p>
            </div>

            <div className="info-section">
              <h3>📦 Metodo di Spedizione</h3>
              <p>Spedizione Standard</p>
              <p>Consegna in 24-48 ore</p>
              {order.shippingCost === 0 && <p className="free-shipping">Spedizione Gratuita</p>}
            </div>
          </div>
        </div>

        <div className="order-items-section">
          <h2>Articoli Ordinati</h2>
          <table className="order-items-table">
            <thead>
              <tr>
                <th>Prodotto</th>
                <th>Prezzo Unitario</th>
                <th>Quantità</th>
                <th>Totale</th>
              </tr>
            </thead>
            <tbody>
              {order.items.map((item) => (
                <tr key={item.id}>
                  <td className="product-name-col">
                    <span><img src={item.image} width={"20%"}/></span> {item.name}
                  </td>
                  <td>€{item.price.toFixed(2)}</td>
                  <td className="center">{item.quantity}</td>
                  <td className="right">€{(item.price * item.quantity).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="order-totals">
          <div className="total-item">
            <span>Subtotale:</span>
            <span>€{order.subtotal.toFixed(2)}</span>
          </div>
          <div className="total-item">
            <span>Spedizione:</span>
            <span>{order.shippingCost === 0 ? "GRATIS" : `€${order.shippingCost.toFixed(2)}`}</span>
          </div>
          <div className="total-item grand-total">
            <span>Totale Ordine:</span>
            <span>€{order.total.toFixed(2)}</span>
          </div>
        </div>

        <div className="next-steps">
          <h3>Prossimi Passi</h3>
          <div className="steps-list">
            <div className="step">
              <span className="step-icon">1️⃣</span>
              <p>Riceverai una conferma via email con i dettagli dell'ordine</p>
            </div>
            <div className="step">
              <span className="step-icon">2️⃣</span>
              <p>Prepariamo il tuo ordine nel nostro magazzino</p>
            </div>
            <div className="step">
              <span className="step-icon">3️⃣</span>
              <p>Riceverai un numero di tracciamento via email</p>
            </div>
            <div className="step">
              <span className="step-icon">4️⃣</span>
              <p>Il tuo ordine arriverà tra 24-48 ore</p>
            </div>
          </div>
        </div>

        <div className="contact-info">
          <h3>Hai domande?</h3>
          <p>Contattaci a <strong>info@pallethub.com</strong> o al <strong>+39 123 456 7890</strong></p>
          <p>Orari: Lun-Ven 9:00-17:00</p>
        </div>

        <div className="action-buttons">
          <Link to="/products" className="continue-btn">
            Continua lo Shopping
          </Link>
          <Link to="/" className="home-btn">
            Torna alla Home
          </Link>
        </div>

        <div className="print-section">
          <button onClick={() => window.print()} className="print-btn">
            🖨️ Stampa Ordine
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirm;
